import Request from 'plugin-tigre-request';
import utils from '@/utils';
import { getUserId, getUserCountry, getToken } from '../userData';

const basePath = 'venusa/familia';

const defaultRequestParam = (path) => {
  return {
    ...utils.makeDefaultRequestData(),
    resource: path,
  };
};
const types = {
  DATA_TO_LIST: 'setDataToList',
};
export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    getList(state) {
      return state.list;
    },
  },
  mutations: {
    setDataToList(state, payload) {
      const { data } = payload;
      state.list = data == null ? [] : data;
    },
    clearState(state) {
      state.list = [];
    },
  },
  actions: {
    async setDataToList({ commit }, data) {
      const USERID = getUserId();

      let requestParam = {
        ...defaultRequestParam(basePath),
        data: { ...data, USERID, ...getUserCountry(), TOKEN: getToken() },
        method: 'GET',
      };

      let response;
      try {
        response = await Request(requestParam);
        commit(types.DATA_TO_LIST, {
          data: response.data.lista,
          request: requestParam,
        });
      } catch (error) {
        response = error;
      }
      return response;
    },

    clearState({ commit }) {
      commit(types.CLEAR_STATE);
    },
  },
};
